export enum UIStateMenu {
    HIDDEN,
    DEVICE_MENU,
    MANAGE,
    REPORTS,
    PROFILE_MENU,
}
